import { Box, Flex, Heading, Icon, Image, Link ,Spacer, Text, Stack, useColorModeValue } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { FaChalkboardTeacher, FaChartPie, FaClipboardCheck, FaQuoteRight, FaUsers, FaVest, FaCog, FaMapMarkedAlt, FaMapMarkerAlt, FaMap } from "react-icons/fa";
import { RiBook3Fill, RiComputerFill, RiHomeSmile2Line, RiMapPin4Fill, RiUserStarFill, RiMoneyDollarBoxLine } from "react-icons/ri";
import { MdGrade, MdAddChart,MdMonetizationOn, MdScience, MdSettings, MdTableChart,MdPersonOutline ,MdAssignment,MdPersonAdd,MdOutlineAccountTree,MdOutlineAddModerator,MdAccessibility} from "react-icons/md";
import { FcPieChart } from "react-icons/fc";
import { useSelector } from "react-redux";
import logo from '../../assets/img/green-technology.png'
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchMenu } from '../../features/menuSlice';

// Función para construir la jerarquía de menús
const buildMenuHierarchy = (menu) => {
    const menuMap = {}; // Mapeo por ID
    const tree = [];

    // Construye un mapa para acceder fácilmente a los nodos
    menu.forEach((item) => {
        menuMap[item.id] = { ...item, children: [] };
    });

    // Construye la jerarquía padre-hijo
    menu.forEach((item) => {
        if (item.padre_id) {
            menuMap[item.padre_id].children.push(menuMap[item.id]);
        } else {
            tree.push(menuMap[item.id]); // Es un menú raíz
        }
    });

    return tree;
};


export const NavItem = ({ icon, children, isSelected, ...rest }) => {

    const bgActiveLinkColor = useColorModeValue("gray.800", "gray.800");

   // const { icon, iconSize, children, isSelected, ...rest } = props;

    return (
        <Flex
            align="center"
            py="7px"
            borderRadius={'lg'}
            px={"4px"}
            cursor="pointer"
            _hover={{
                bg: bgActiveLinkColor,
            }}
            _activeLink={{
                color: isSelected ? "blue.500" : "inherit",
            }}
            role="group"
            transition=".1s ease"
            {...rest}
        >
            {icon && (
                <Icon
                    mx="4"
                    ml={{ base: "1", md: "3" }}
                    fontSize="23px"
                    as={icon}
                    color={isSelected ? "blue.500" : "inherit"}
                    {...rest}
                />
            )}
            {children}
        </Flex>
    );
};


function Sidebar({ isOpen }) {

    const dispatch = useDispatch();
    const { menu, status } = useSelector((state) => state.menu);
    const { rol } = useSelector((state) => state.auth);
    const rolKey = rol;

    //console.log('Rol del usuario:', rolKey); // Verifica el rol del usuario

    const permisosPorRol = {
        admin: ['*'], // acceso completo
        operador: [
            'ver_modulo_inicio',
            'ver_modulo_servicio',
            'ver_modulo_ciudad',
            'ver_modulo_configuraciones',
            'ver_modulo_cliente',
            'ver_modulo_factura',
            'ver_modulo_presupuesto'
        ]
    }

    const tienePermiso = (key) => {
        const permisos = permisosPorRol[rolKey] || [];
        return permisos.includes('*') || permisos.includes(key);
    };

    const menuFiltrado = menu.filter((item) => tienePermiso(item.key)); // Usa item.key o el campo correcto


    useEffect(() => {
        if (status === "idle") {
            dispatch(fetchMenu()); 
        }
    }, [dispatch, status]);


    const activeLinkcolor = useColorModeValue("white", "white");
    const bgActiveLinkColor = useColorModeValue("gray.800", "gray.800");

 
    const icons = {
        RiHomeSmile2Line: RiHomeSmile2Line,
        FaUsers: FaUsers,
        RiUserStarFill: RiUserStarFill,
        FaChalkboardTeacher: FaChalkboardTeacher,
        MdMonetizationOn: MdMonetizationOn,
        RiComputerFill: RiComputerFill,
        RiBook3Fill: RiBook3Fill,
        MdTableChart: MdTableChart,
        FaVest: FaVest,
        FaClipboardCheck: FaClipboardCheck,
        MdGrade: MdGrade,
        FaQuoteRight: FaQuoteRight,
        MdSettings: MdSettings,
        RiMapPin4Fill: RiMapPin4Fill,
        MdScience: MdScience,
        FcPieChart: FcPieChart,
        FaChartPie: FaChartPie,
        RiMoneyDollarBoxLine: RiMoneyDollarBoxLine,
        FaMapMarkedAlt: FaMapMarkedAlt,
        FaMapMarkerAlt: FaMapMarkerAlt ,
        FaMap : FaMap,
        MdPersonOutline: MdPersonOutline,
        MdAssignment: MdAssignment,
        MdPersonAdd: MdPersonAdd,
        MdOutlineAccountTree: MdOutlineAccountTree,
        MdOutlineAddModerator:MdOutlineAddModerator,
        MdAccessibility: MdAccessibility,
        MdAddChart: MdAddChart
    };

    
    const thirdListItem = [
        {
            nombre: "Configuraciones",
            url: "/configuraciones",
            icon: FaCog
        }
    ]

    return (
        <Box
            w={{ base: isOpen ? "0" : "0", lg: "280px" }}
            display={{
                base: isOpen ? "block" : "none",
            }}
            bgColor="primary.1000"
            _dark={{
                bgColor: "primary.1000",
                color: "white",
                borderRight: '1px solid rgba(255, 255, 255, 0.1)'
            }}
            borderRight='0.1px solid rgba(0, 0, 0, 0.02)'
            color="white"
            pos="fixed"
            top="0"
            left="0"
            bottom="0"
            h="calc(100vh - 0rem)"
            overflow="hidden"
            overflowY="auto"
            zIndex="0"
            transform={isOpen ? "translateX(0)" : "translateX(-100%)"}
            transition="width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms"
            sx={{
                '&::-webkit-scrollbar': {
                    width: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: useColorModeValue('#909090', '#717171'),
                    borderRadius: '24px',
                    width: '4px',
                },
                '&::-webkit-scrollbar-thumb:active': {
                    backgroundColor: useColorModeValue('#909090', '#717171'),
                },
                '&::-webkit-scrollbar-track': {
                    borderRadius: '24px',
                },
            }}
        >
            <Flex
                direction="column"
                as="nav"
                fontSize="15px"
                px={4}
                py={2}
                aria-label="Main Navigation"
                h="100%"
            >
                <Flex
                    direction="row"
                    px={1.5}
                    py={4}
                    mb={2}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                >
                    <Stack alignItems={'center'} direction='row' spacing={4} w="full">
                        <Box
                            w="40px"
                            h="40px"
                            borderRadius="lg"
                            borderColor={'gray.700'}
                            borderWidth="1px"
                            p={'4px'}
                        >
                            <Image
                                src={logo}
                                alt="logo"
                                w="full"
                                alignSelf={'center'}
                                h="full"
                                objectFit="cover"
                            />
                        </Box>
                        <Stack direction="column" spacing={0}>
                            <Heading
                                fontSize="16px"
                                fontWeight="bold"
                                color="white"
                                alignSelf={'start'}
                                justifySelf={'start'}
                                textAlign="start"
                            >
                                SIGNIA
                            </Heading>
                            <Text
                                fontSize="14px"
                                color="gray.400"
                                _dark={{
                                    color: "gray.400"
                                }}
                                alignSelf={'start'}
                                justifySelf={'start'}
                                textAlign="start"
                            >
                            
                            </Text>
                        </Stack>
                    </Stack>
                </Flex>
                {
                    // Mapea los menús dinámicos
                    menuFiltrado.map((item, index) => {
                        //console.log('Estoy corriendo aqui ... 1 ')
                        const isSelected = item.path === window.location.pathname;

                        return (
                            <Link
                                key={index}
                                as={NavLink}
                                to={item.url}
                                fontSize={'15px'}
                                fontWeight={'semibold'}
                                color={'gray.400'}
                                borderRadius={'lg'}
                                mb={1}
                                _activeLink={{
                                    color: activeLinkcolor,
                                    bg: bgActiveLinkColor,
                                }}
                                _hover={{ textDecoration: 'none' }}
                            >
                                <NavItem isSelected={isSelected} icon={icons[item.icono]}>{item.nombre}</NavItem>
                        
                            </Link>
                        )
                    })

                }
                <Spacer />

                <Stack
                    bottom={0}
                    direction="column"
                    as="nav"
                    fontSize="12px"
                    aria-label="Main Navigation"
                >
                    {
                        thirdListItem.map((item, index) => {
                           // console.log('Estoy corriendo aqui ... 2 ')
                            const isSelected = item.path === window.location.pathname;
                            return (
                                <Link
                                    key={index}
                                    as={NavLink}
                                    to={item.url}
                                    fontSize={'15px'}
                                    fontWeight={600}
                                    color={'gray.400'}
                                    _dark={{
                                        color: 'gray.400',
                                    }}
                                    borderRadius={'lg'}
                                    mb={1}
                                    _activeLink={{
                                        color: activeLinkcolor,
                                        bg: bgActiveLinkColor,
                                        _dark: {
                                            color: 'blue.600'
                                        }
                                    }}
                                    _hover={{ textDecoration: 'none' }}
                                >
                                    <NavItem isSelected={isSelected} icon={item?.icon}>{item?.nombre}</NavItem>
                                </Link>
                            )
                        })
                    }
                </Stack>
            </Flex>
        </Box>
    );
}

export default Sidebar;